var _circle, _circle2, _circle3, _path, _path2, _path3, _circle4, _circle5, _path4, _path5, _path6, _path7;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgLoading = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "spinner",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.145,
    cy: 6.145,
    r: 6.145,
    transform: "translate(43.855)",
    fill: "rgba(183,190,197,0.8)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.145,
    cy: 6.145,
    r: 6.145,
    transform: "translate(43.855 87.71)",
    fill: "rgba(183,190,197,0.2)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.145,
    cy: 6.145,
    r: 6.145,
    transform: "translate(21.927 7.579)",
    fill: "rgba(183,190,197,0.7)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M347.579,421.581a6.149,6.149,0,1,1-8.4-2.253A6.323,6.323,0,0,1,347.579,421.581Z",
    transform: "translate(-270.322 -338.378)",
    fill: "rgba(183,190,197,0.1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.926,112.8a6.149,6.149,0,1,1-8.4,2.253A6.089,6.089,0,0,1,38.926,112.8Z",
    transform: "translate(-22.129 -90.047)",
    fill: "rgba(183,190,197,0.6)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M427.726,336.928a6.149,6.149,0,1,1-8.4,2.253A6.219,6.219,0,0,1,427.726,336.928Z",
    transform: "translate(-338.378 -270.322)",
    fill: "rgba(183,190,197,0.05)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.145,
    cy: 6.145,
    r: 6.145,
    transform: "translate(0 43.855)",
    fill: "rgba(183,190,197,0.5)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.145,
    cy: 6.145,
    r: 6.145,
    transform: "translate(87.71 43.855)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.517,336.928a6.149,6.149,0,1,1-2.253,8.4C28.42,342.458,29.649,338.771,32.517,336.928Z",
    transform: "translate(-21.865 -270.322)",
    fill: "rgba(183,190,197,0.4)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M421.581,112.928a6.149,6.149,0,1,1-2.253,8.4A6.323,6.323,0,0,1,421.581,112.928Z",
    transform: "translate(-338.378 -90.185)",
    fill: "#b7bec5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M112.928,421.581a6.149,6.149,0,1,1,2.253,8.4A6.323,6.323,0,0,1,112.928,421.581Z",
    transform: "translate(-90.185 -338.378)",
    fill: "rgba(183,190,197,0.3)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M336.928,32.781a6.149,6.149,0,1,1,2.253,8.4A6.219,6.219,0,0,1,336.928,32.781Z",
    transform: "translate(-270.322 -22.129)",
    fill: "rgba(183,190,197,0.9)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLoading, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/loading.790a22ae.svg";
export { ForwardRef as ReactComponent };